let _token = null;

export const setProxyToken = (token) => { _token = token; };
export const getProxyToken = () => _token;
export const clearProxyToken = () => { _token = null; };
